import { useEffect } from "react";
import "../styles/Home.scss";
import { FaChevronDown } from "react-icons/fa";
import Jobs from "./Jobs";
import { scrollToElement } from "../utils/scrollHelper";

const Home = () => {
  useEffect(() => {
    // Check for hash in URL on component mount
    const hash = window.location.hash.slice(1); // Remove the # symbol
    if (hash) {
      // Small delay to ensure the page is fully loaded
      setTimeout(() => scrollToElement(hash), 100);
    }
  }, []);

  const handleScrollClick = () => {
    // Get the experience heading element
    const experienceHeading = document.querySelector(".jobs__title"); // Adjust this selector based on your Jobs component's heading class

    if (experienceHeading) {
      const headerOffset = 80; // Increased offset to scroll less far
      const elementPosition = experienceHeading.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="app">
      <section className="app__hero">
        <h1>Ryan Huse</h1>
        <h2>Software Engineer & Developer</h2>
        <p>Creating digital experiences that matter</p>
        <FaChevronDown
          className="app__scroll-indicator"
          size={24}
          onClick={handleScrollClick}
          style={{ cursor: "pointer" }}
        />
      </section>
      <Jobs />
    </div>
  );
};

export default Home;
